<template>
  <div class="playlist">
    <a 
      v-for="(video, index) in videos" 
      @click.prevent="$emit('select-video', video)" 
      :key="index" 
      :class="{ selected: video.id == currVideo.id }" 
      class="video-link rounded" 
      href="#">
      <video-card :video="video"></video-card>
    </a>
  </div>
</template>

<script>
import VideoCard from '@/VideoCard.vue'

export default {
  name: 'Playlist',
  components: {
    VideoCard
  },
  props: {
    videos: {
      type: Array,
      required: true
    },
    currVideo: {
      type: Object
    }
  },
  computed: {
    config () {
      return this.$root.$options.config
    }/* ,
    playerHeight() {
      const obj = document.getElementById('video-player-' + this.config.id)
      console.log('obj', obj)
      if (obj) {
        return obj.clientHeight + 'px'
      } else {
        return '0px'
      }
    } */
  }
}
</script>
